// third party
import * as yup from 'yup';

// project imports
import { getRegexrForVat } from 'utils/regexr';
import { validationSchema as phoneNumberValidationSchema } from '../../common/phone-number';
import { validationSchema as locationValidationSchema } from '../../common/location';
import { validationSchema as contactValidationSchema } from '../contact';

const validationSchema = (intl) =>
    yup.object().shape({
        name: yup
            .string()
            .max(255, intl.formatMessage({ id: 'ui-comp-formvalidation-name-max', values: { maxValue: 255 } }))
            .required(intl.formatMessage({ id: 'ui-comp-formvalidation-name-required' })),
        mainAddress: yup.string().nullable(),
        mainTown: yup
            .string()
            .max(255, intl.formatMessage({ id: 'ui-comp-formvalidation-town-max', values: { maxValue: 255 } }))
            .nullable(),
        vatin: yup
            .string()
            .matches(getRegexrForVat(), { message: intl.formatMessage({ id: 'ui-comp-formvalidation-vatin-invalid' }) })
            .uppercase()
            .nullable(),
        partnershipType: yup.object().shape({}).nullable(),
        mainEmails: yup
            .array()
            .of(
                yup
                    .string()
                    .email(intl.formatMessage({ id: 'ui-comp-formvalidation-email-invalid' }))
                    .lowercase()
            )
            .nullable(),
        mainPhoneNumbers: yup.array().of(phoneNumberValidationSchema(intl)).nullable(),
        contacts: yup.array().of(contactValidationSchema(intl)).nullable(),
        locations: yup.array().of(locationValidationSchema(intl)).nullable()
    });

export default validationSchema;
